<template>
  <callback-status variant="success" />
</template>

<script>
import CallbackStatus from './CallbackStatus.vue'

export default {
  components: { CallbackStatus },
}
</script>
